import script from "./Star.vue?vue&type=script&setup=true&lang=js"
export * from "./Star.vue?vue&type=script&setup=true&lang=js"

import "./Star.vue?vue&type=style&index=0&id=6d9283b8&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9283b8"]])

export default __exports__